import { render, staticRenderFns } from "./KPIStatistics.vue?vue&type=template&id=30896906&"
import script from "./KPIStatistics.vue?vue&type=script&lang=js&"
export * from "./KPIStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports